<template>
  <div class="row m-0">
    <mobile-menu class="d-block d-lg-none" @goTo="goTo" :active_page="active"></mobile-menu>
    <div class="col items info p-0" @click.self="goTo('information')" @mouseover="mouseOver('information')" @mouseout="mouseOut('information')" :class="{'active': active == 'information', 'previous': previous == 'information', 'hovering': hover == 'information', 'previoushover': previoushover == 'information'}">
      <div class="overlay_everything" v-if="active != 'information'" @click.self="goTo('information')" @mouseover="mouseOver('information')" @mouseout="mouseOut('information')"></div>
      <information pageId='11'></information>
    </div>
    <div class="col items talks p-0" @click.self="goTo('talks')" @mouseover="mouseOver('talks')" @mouseout="mouseOut('talks')" :class="{'active': active == 'talks', 'previous': previous == 'talks', 'hovering': hover == 'talks', 'previoushover': previoushover == 'talks'}">
      <div class="overlay_everything" v-if="active != 'talks'" @click.self="goTo('talks')" @mouseover="mouseOver('talks')" @mouseout="mouseOut('talks')"></div>
      <talks postType='talks' taxonomy='talk_category' :nav='currentPost'></talks>
    </div>
    <div class="col items teaching p-0" @click.self="goTo('teaching')" @mouseover="mouseOver('teaching')" @mouseout="mouseOut('teaching')" :class="{'active': active == 'teaching', 'previous': previous == 'teaching', 'hovering': hover == 'teaching', 'previoushover': previoushover == 'teaching'}">
      <div class="overlay_everything" v-if="active != 'teaching'" @click.self="goTo('teaching')" @mouseover="mouseOver('teaching')" @mouseout="mouseOut('teaching')"></div>
      <teaching postType='teaching' taxonomy='teaching_category' :nav='currentPost'></teaching>
    </div>
    <div class="col items writing p-0" @click.self="goTo('writing')" @mouseover="mouseOver('writing')" @mouseout="mouseOut('writing')" :class="{'active': active == 'writing', 'previous': previous == 'writing', 'hovering': hover == 'writing', 'previoushover': previoushover == 'writing'}">
      <div class="overlay_everything" v-if="active != 'writing'" @click.self="goTo('writing')" @mouseover="mouseOver('writing')" @mouseout="mouseOut('writing')"></div>
      <writing postType='writing' taxonomy='writing_category' :nav='currentPost'></writing>
    </div>
    <div class="col items curating p-0" @click.self="goTo('curating')" @mouseover="mouseOver('curating')" @mouseout="mouseOut('curating')" :class="{'active': active == 'curating', 'previous': previous == 'curating', 'hovering': hover == 'curating', 'previoushover': previoushover == 'curating'}">
      <div class="overlay_everything" v-if="active != 'curating'" @click.self="goTo('curating')" @mouseover="mouseOver('curating')" @mouseout="mouseOut('curating')"></div>
      <curating postType='curating' taxonomy='curating_category' :nav='currentPost'></curating>
    </div>
    <div class="col items ideas p-0" @click.self="goTo('ideas')" @mouseover="mouseOver('ideas')" @mouseout="mouseOut('ideas')" :class="{'active': active == 'ideas', 'previous': previous == 'ideas', 'hovering': hover == 'ideas', 'previoushover': previoushover == 'ideas'}">
      <div class="overlay_everything" v-if="active != 'ideas'" @click.self="goTo('ideas')" @mouseover="mouseOver('ideas')" @mouseout="mouseOut('ideas')"></div>
      <ideas pageId='922' @goTo="goTo"></ideas>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  mounted() {
    if (typeof this.$route.params.page !== 'undefined') {
      this.active = this.$route.params.page
    }
  },
  watch: {
    '$route' () {
      if (typeof this.$route.params.page !== 'undefined') {
        this.active = this.$route.params.page
      }
    }
  },
  components: {
    'information': () => import('../pages/Information.vue'),
    'talks': () => import('../pages/Talks.vue'),
    'teaching': () => import('../pages/Teaching.vue'),
    'writing': () => import('../pages/Writing.vue'),
    'curating': () => import('../pages/Curating.vue'),
    'ideas': () => import('../pages/Ideas.vue'),
    'mobile-menu': () => import('../components/Menu.vue')
  },
  data () {
    return {
      previous: '',
      active: 'ideas',
      hover: '',
      previoushover: '',
      currentPost: ''
    }
  },
  methods: {
    goTo (val) {
      this.$router.push('/'+val)
      this.previous = this.active
      this.active = val
      this.currentPost = val
    },
    mouseOver (val) {
      this.hover = val
    },
    mouseOut () {
      this.previoushover = this.hover
      this.hover = ''
    }
  }
}
</script>

<style scoped>
.items {
  display: none;
}
.active {
  width: 100vw;
  display: block;
  overflow-y: auto;
}
@media (min-width: 992px) {
  .items {
    display: inline-flex;
    height: 100vh;
    width: 8vw;
    flex-basis: unset;
  }
  .items.previous {
    width: 8vw;
    animation-name: fromActive;
    animation-duration: .3s;
    animation-iteration-count: 1;
  }
  .items.hovering {
    width: 9vw;
    margin-left: -1vw;
    animation-name: toHover;
    animation-duration: .2s;
    animation-iteration-count: 1;
    cursor: pointer;
  }
  .items.previoushover {
    width: 8vw;
    margin-left: 0;
    animation-name: fromHover;
    animation-duration: .2s;
    animation-iteration-count: 1;
  }
  .active {
    width: 60vw;
    position: relative;
    top: inherit;
    left: inherit;
    overflow-y: auto;
    /* margin-right: -15px;
    overflow-x: hidden; */
  }
  .items.active {
    width: 60vw;
    animation-name: toActive;
    animation-duration: .3s;
    animation-iteration-count: 1;
  }
  .items.active.hovering {
    margin-left: 0;
    cursor: default;
  }
  @keyframes toActive {
    0%   {width: 8vw;}
    25%  {width: 24vw;}
    50%  {width: 44vw;}
    100% {width: 60vw;}
  }
  @keyframes fromActive {
    0%   {width: 60vw;}
    25%  {width: 44vw;}
    50%  {width: 24vw;}
    100% {width: 8vw;}
  }
  @keyframes toHover {
    0%   {width: 8vw; margin-left:0}
    100%  {width: 9vw; margin-left:-1vw}
  }
  @keyframes fromHover {
    100%   {width: 8vw; margin-left:0}
    0%  {width: 9vw; margin-left:-1vw}
  }
}
@media (min-width: 1200px) {
  .items {
    height: 100vh;
    width: 7vw;
  }
  .items.previous {
    width: 7vw;
    animation-name: fromActive;
    animation-duration: .3s;
    animation-iteration-count: 1;
  }
  .items.hovering {
    width: 8vw;
    margin-left: -1vw;
  }
  .active {
    width: 65vw;
  }
  .items.active {
    width: 65vw;
  }
  @keyframes toActive {
    0%   {width: 7vw;}
    25%  {width: 27vw;}
    50%  {width: 45vw;}
    100% {width: 65vw;}
  }
  @keyframes fromActive {
    0%   {width: 65vw;}
    25%  {width: 45vw;}
    50%  {width: 27vw;}
    100% {width: 7vw;}
  }
  @keyframes toHover {
    0%   {width: 7vw; margin-left:0}
    100%  {width: 8vw; margin-left:-1vw}
  }
  @keyframes fromHover {
    100%   {width: 7vw; margin-left:0}
    0%  {width: 8vw; margin-left:-1vw}
  }
}
</style>